<template>
  <div class="cooperation-add-wrapper global-card">
    <bread-crumb />
    <div class="form-card-wrapper">
      <a-card :bordered="false" style="width: 100%; border-radius: 10px">
        <form-card
          ref="formcard1"
          title="服务计划"
          :form-data="formData1"
          class="plan-class"
        >
          <template #name>
            <a-input v-decorator="['name', { initialValue: name }]" disabled />
          </template>
          <template #agreement_id>
            <a-select
              v-decorator="[
                'agreement_id',
                {
                  rules: [{ required: true, message: '请选择选择协议' }],
                  initialValue: data1.agreement_id,
                },
              ]"
              :disabled="$route.query.status !== undefined"
              @select="handleSelect"
            >
              <a-select-option
                v-for="item in agreementData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </a-select-option>
            </a-select>
          </template>
          <template #taxscale>
            <a-input
              :value="
                $refs.formcard1
                  ? getTaxscale(
                      getTotal(agreement_service),
                      $refs.formcard1.form.getFieldValue('materials_cost')
                    )
                  : 0
              "
              disabled
              addon-after="元"
            />
          </template>
          <template #company>
            <a-input
              v-decorator="['company', { initialValue: data1.company }]"
              disabled
            />
          </template>

          <template #province_city>
            <province-city
              v-decorator="[
                'province_city',
                {
                  initialValue: data1.province_city,
                },
              ]"
              :pro-and-city-disabled="true"
            />
          </template>
          <template #budget>
            <a-input
              v-decorator="['company', { initialValue: data1.budget }]"
              disabled
              addon-after="元"
            />
          </template>

          <template #title>
            <a-input
              v-decorator="[
                'title',
                {
                  rules: [{ required: true, message: '请输入任务名称' }],
                  initialValue: data1.title,
                },
              ]"
              placeholder="请输入任务名称"
            />
          </template>
          <template #materials_cost>
            <a-input
              v-decorator="[
                'materials_cost',
                {
                  initialValue: data1.materials_cost,
                },
              ]"
              type="number"
              :min="0"
              addon-after="元"
              placeholder="请输入物料费"
            />
          </template>
          <template #plan_time>
            <a-range-picker
              v-decorator="[
                'plan_time',
                {
                  rules: [
                    { required: true, message: '请选择协议开始和结束日期' },
                  ],
                  initialValue: data1.plan_time,
                },
              ]"
              style="width: 100%"
            />
          </template>
        </form-card>
        <div class="form-card-title">
          任务详情
          <span
            v-show="
              selectedRowKeys.length === 0 && agreement_service.length !== 0
            "
            class="error-note-title"
            >至少选择一个项目</span
          >
        </div>
        <form-card ref="formcard2" :form-data="formData2">
          <template #name>
            <a-table
              :pagination="false"
              :columns="columns1"
              :data-source="agreement_service"
              :loading="loading"
              :row-key="(record) => record.service_id"
              :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
              }"
            >
              <template slot="plan_num" slot-scope="plan_num, record, index">
                <div class="table-input">
                  <a-input-number
                    v-model="agreement_service[index].plan_num"
                    :min="1"
                    placeholder="任务数量"
                    class="input-number"
                    :formatter="(value) => (value ? `${value}次` : undefined)"
                    :parser="(value) => value.replace('次', '')"
                  />
                  <div class="error-note">
                    <span
                      v-if="
                        selectedRowKeys.includes(record.service_id) &&
                        !agreement_service[index].plan_num
                      "
                      >请输入任务数量</span
                    >
                  </div>
                </div>
              </template>
              <template slot="operation" slot-scope="operation, record">
                <!-- 线上调研 -->
                <div style="display: flex" v-if="record.service_id == 19">
                  <div>
                    <el-checkbox v-model="record.offline_share.offline"
                      >线下</el-checkbox
                    >
                  </div>
                  <div style="margin-left: 20px">
                    <el-checkbox v-model="record.offline_share.share"
                      >分享</el-checkbox
                    >
                  </div>
                </div>

                <!-- 竞品信息收集、数据流向收集 -->
                <div style="display: flex" v-if="record.need_show_product">
                  <a-select
                    mode="multiple"
                    style="width: 240px"
                    placeholder="请选择产品"
                    :showArrow="true"
                    :defaultValue="record.relation_product_names"
                    @change="handleProductChange"
                    @deselect="deselectProductChange"
                  >
                    <div slot="dropdownRender" slot-scope="products">
                      <v-nodes :vnodes="products" />
                      <a-divider style="margin: 4px 0" />
                      <div
                        style="padding: 4px 8px; cursor: pointer"
                        @mousedown="(e) => e.preventDefault()"
                        @click="addItem"
                      >
                        <a-row type="flex" align="middle" :gutter="4">
                          <a-col :span="24" :order="1">
                            <span style="color: #409eff">
                              <a-icon type="plus" /> 新增
                            </span>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                    <a-select-option
                      v-for="item in product_names"
                      :key="record.service_id"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </div>
              </template>

              <!-- 产品选择 -->
              <template
                slot="related_product"
                slot-scope="related_product, record"
                v-if="record.need_relation_product"
              >
                <a-select
                  placeholder="选择关联产品"
                  :showSearch="true"
                  :labelInValue="false"
                  :defaultValue="
                    setProductDefaultSelect(
                      record.relation_for_product,
                      record.relation_for_datas,
                      record.service_id
                    )
                  "
                  @change="getproductsId"
                  style="width: 180px"
                >
                  <a-select-option
                    v-for="item in productsData"
                    :key="item.id"
                    :value="
                      item.id + '_+_' + record.service_id + '_+_' + item.title
                    "
                  >
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </template>

              <!-- 资料选择 -->
              <template
                slot="related_informations"
                slot-scope="related_informations, record"
                v-if="record.need_relation_product"
              >
                <a-select
                  :placeholder="setDatasPlaceholder(record.service_id)"
                  :disabled="isProductsDataDisabled(record.service_id)"
                  @select="getdatasdinfo"
                  @deselect="deletedatasdinfo"
                  mode="multiple"
                  :defaultValue="record.relation_for_datas"
                  :value="datasOnSelects(record.service_id)"
                  dropdownClassName="datas_drop_down"
                  style="width: 200px"
                >
                  <a-select-option
                    v-for="item in datasOnProducts(record.service_id)"
                    :key="record.service_id"
                    :value="
                      item.id + '_+_' + record.service_id + '_+_' + item.name
                    "
                    :code="item.type"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </template>

              <!-- 金额 -->
              <template slot="amount" slot-scope="amount, record">
                {{
                  record.budget && record.plan_num
                    ? `${formattedAmount(record.budget * record.plan_num)}元`
                    : ""
                }}
              </template>
              <template slot="footer">
                <div style="overflow: hidden">
                  <span style="float: left">任务总额</span>
                  <span style="float: right; padding-right: 131px"
                    >{{ `${getTotal(agreement_service)}元` }}
                  </span>
                </div>
              </template>
            </a-table>
          </template>
        </form-card>
        <form-card v-if="isReject === 2" ref="formcard3" :form-data="formData3">
          <template #flag>
            <a-radio-group
              v-decorator="[
                'flag',
                {
                  initialValue: data3.flag,
                },
              ]"
              name="flag"
              disabled
            >
              <a-radio :value="1"> 同意 </a-radio>
              <a-radio :value="0"> 不同意 </a-radio>
            </a-radio-group>
          </template>
          <template #desc>
            <a-textarea
              v-decorator="[
                'desc',
                {
                  initialValue: data3.desc,
                },
              ]"
              disabled
              :autosize="{ minRows: 2 }"
            />
          </template>
        </form-card>
        <form-button
          :btn-is-loading="btnIsLoading"
          class="form-card-button"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </a-card>
    </div>
    <!-- 新增产品 -->
    <add-product-modal
      ref="addProductRef"
      :visible="addProductVisible"
      @onCancel="onCancelAddProduct"
      @onSubmit="saveProduct"
    />
  </div>
</template>
<script>
import { formData1, columns1, formData2, formData3 } from "./../data";
import AddProductModal from "../modal/AddProductModal";

export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
    AddProductModal,
  },
  data() {
    return {
      btnIsLoading: false,
      datasData: [],
      columns1,
      agreement_service: [],
      selectedRowKeys: [],
      formData1,
      formData2,
      formData3,
      loading: false,
      agreementData: [],
      data1: {},
      productsData: [],
      data3: {},
      name: "",
      agreement_id: "",
      Status: undefined,
      list: [],
      cooperation_company_id: null,
      datas_placeholder: [],
      isReject: 0,
      // 添加商品弹窗
      addProductVisible: false,
      // 已选择的产品
      productSelects: [],
      // 产品列表
      product_names: [],
      relation_product_ids: "",
      product_specs: [],
      product_datas: {},
      product_datas_disabled: [],
      // 每个服务类型选择的资料
      service_data_selectArr: [],
      // 服务类型关联的产品id
      service_product_selectArr: [],
    };
  },
  computed: {
    // 处理动态的商品关联资料
    datasOnProducts() {
      return function (serviceId) {
        return this.product_datas["dataList_" + serviceId];
      };
    },
    isProductsDataDisabled() {
      return function (serviceId) {
        return this.product_datas_disabled[serviceId] == undefined
          ? true
          : this.product_datas_disabled[serviceId];
      };
    },
    datasOnSelects() {
      return function (serviceId) {
        if (this.service_data_selectArr[serviceId] == undefined) {
          return [];
        }
        return this.service_data_selectArr[serviceId];
      };
    },
    setProductDefaultSelect: {
      get() {
        return function (product, datas, serviceId) {
          if (!product) {
            return ;
          }
          this.product_datas_disabled[serviceId] = false;
          this.service_data_selectArr[serviceId] = datas;
          return product;
        };
      },
      set(val) {
        this.service_product_selectArr[val.serviceId] = parseInt(val.productId);
      },
    },
    setDatasPlaceholder() {
      return function (serviceId) {
        return this.datas_placeholder[serviceId] || "选择关联产品后展示";
      };
    },
  },
  async created() {
    // 获取status
    if (this.$route.query.status === 0 || this.$route.query.status) {
      this.Status = parseInt(this.$route.query.status);
    }
    // 获取协议信息
    await this.getAgreement();
    // 获取用户信息
    await this.getUser();

    // 数据回显
    if (this.Status !== undefined) {
      this.getAgreemntInfo({ id: this.$route.query.id });
    }
  },
  methods: {
    setSetProductDefaultSelect(serviceId, productId) {
      this.setProductDefaultSelect = {
        serviceId: serviceId,
        productId: productId,
      };
    },
    // 选中商品
    handleProductChange(value, option) {
      if (value.length === 0) {
        return;
      }

      this.productSelects[option[0].data.key] = value;
    },
    deselectProductChange(value, option) {
      let indexOfSelect = this.productSelects[option.data.key].indexOf(value);
      this.productSelects[option.data.key].splice(indexOfSelect, 1);
    },
    // 保存新增产品名称
    saveProduct(name, spec) {
      this.product_names.push(name);
      this.product_specs.push({ name, spec });
      this.onCancelAddProduct();
    },
    // 关闭新增产品的弹窗
    onCancelAddProduct() {
      this.addProductVisible = false;
    },
    // 显示新增产品的弹窗
    addItem() {
      this.addProductVisible = true;
    },
    // 获取产品
    async getProducts() {
      let result = await this.$http.post("/product/getList", {
        cooperation_company_id: this.cooperation_company_id,
      });
      if (result.data.status === 1) {
        this.productsData = result.data.data.data_list.filter(
          (item) => item.status === 1
        );

        this.product_names = result.data.data.data_list.map(function (item) {
          if (item.status == 1) {
            return item.title;
          }
        });
      }
    },
    async getproductsId(val) {
      console.log("getproductsId:val-->", val);

      if (val === undefined) {
        return;
      }

      let psId = val.split("_+_");
      let productId = psId[0];
      let serviceId = psId[1];

      this.product_datas_disabled[serviceId] = false;
      this.$refs.formcard1.form.setFieldsValue({
        datas: [],
      });
      // 重置当前服务类型已选择的资料
      if (this.service_data_selectArr[serviceId] !== undefined) {
        this.service_data_selectArr[serviceId].splice(0);
      }

      this.service_product_selectArr[serviceId] = parseInt(productId);
      this.getproductslist(productId, serviceId);
    },
    async getproductslist(productId, serviceId) {
      let data = {
        product_id: productId,
        agreement_id: this.agreement_id,
      };

      let result = await this.$http.post("/product/relations", data);
      if (result.data.status === 1) {
        this.datasData[serviceId] = result.data.data;
        if (result.data.data.length) {
          this.datas_placeholder[serviceId] = "请选择关联资料";
        } else {
          this.datas_placeholder[serviceId] = "没有可选择的资料";
        }

        this.$set(
          this.product_datas,
          "dataList_" + serviceId,
          this.datasData[serviceId]
        );
      }
    },
    getdatasdinfo(val, option) {
      if (option.data.key in this.service_data_selectArr) {
        this.service_data_selectArr[option.data.key].push(val);
      } else {
        this.$set(this.service_data_selectArr, option.data.key, [val]);
      }
    },
    // 删除已选择的商品
    deletedatasdinfo(val) {
      let psId = val.split("_+_");
      let serviceId = psId[1];
      let indexOfSelect = this.service_data_selectArr[serviceId].indexOf(val);

      this.service_data_selectArr[serviceId].splice(indexOfSelect, 1);
    },
    // 获取发票金额
    getTaxscale(all, materials_cost) {
      if (materials_cost) {
        return (Number(all) + Number(materials_cost)).toFixed(2);
      } else {
        if (!this.data1.materials_cost) {
          return Number(all).toFixed(2);
        } else {
          return (Number(all) + Number(this.data1.materials_cost)).toFixed(2);
        }
      }
    },
    // 数据回显
    async getAgreemntInfo(id) {
      let result = await this.$http.post("/WorkPlan/show", id);
      if (result.data.status === 1) {
        let res = result.data.data;
        this.isproductsDataDisabled = false;
        this.agreement_id = res.agreement_id;
        this.cooperation_company_id = res.company_id;

        res.service_detail.map((item) => {
          if(item.relation_for_product != null){
            this.getproductslist(item.relation_for_product.id, item.id);
          }
        });

        // 回显
        this.handleSelect(res.agreement_id);
        const a = res.product_link_datas.map((item) => {
          return item.map_id;
        });
        this.data1 = {
          agreement_id: res.agreement_id,
          company:
            res.agreement_info.service_provider_info.companyInfo.qichacha_name,
          materials_cost: res.materials_cost,
          province_city: {
            province: res.agreement_info.province,
            city: res.agreement_info.city ? res.agreement_info.city : "",
          },
          title: res.title,
          plan_time: [
            this.$Moment(res.plan_start_time),
            this.$Moment(res.plan_end_time),
          ],
          budget: res.agreement_info.budget,
          link_products: res.agreement_info.agreement_product.map((item) => {
            return item.id;
          }),
          datas: res.product_link_datas.map((item) => {
            return item.map_id;
          }),
        };
        this.agreement_service = this.agreement_service.map((item, index) => {
          const match = res.service_detail.find(
            (service) => service.id === item.service_id
          );
          let plan_num;
          let offline_share = {offline: false, share: false};
          let relation_product_names;
          let relation_for_product;
          let relation_for_datas;

          if (match) {
            this.selectedRowKeys.push(match.id);
            plan_num = match.plan_num;
            relation_product_names = match.relation_product_names;
            this.productSelects[match.id] = relation_product_names;

            offline_share = {
              offline: match.configs.offline,
              share: match.configs.share,
            };

            // 关联的资料
            relation_for_datas = match.relation_for_datas.map(function (item) {
              return (item.map_id + "_+_" + item.service_id + "_+_[" + item.link_datas.obj_type_text + "]" + item.title);
            });

            // 关联的产品
            if(match.relation_for_product != null){
              relation_for_product = match.relation_for_product.id + "_+_" + match.relation_for_product.service_id + "_+_" + match.relation_for_product.title;
              // 设置已选择的产品ID
              this.setSetProductDefaultSelect(item.service_id, match.relation_for_product.id);
            }
            
          }
          return {
            service_id: item.service_id,
            name: item.name,
            budget: item.budget,
            plan_num: plan_num,
            offline_share: offline_share,
            need_relation_product: item.need_relation_product,
            need_show_product: item.need_show_product,
            relation_product_names: relation_product_names,
            relation_for_datas: relation_for_datas,
            relation_for_product: relation_for_product,
          };
        });
        // 驳回意见
        this.isReject = res.status;
        this.data3 = {
          flag: 0,
          desc: res.verify_desc,
        };
      }
    },
    // 格式化金额
    formattedAmount(money) {
      return money.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    // 获取计划总金额
    getTotal(data) {
      let count = 0;
      data.forEach((item) => {
        if (item.budget && item.plan_num) {
          count += item.budget * item.plan_num;
        }
      });
      return count.toFixed(2);//.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    // 获取协议信息
    async getAgreement() {
      let result = await this.$http.post("/agreement/getValidateList", {
        sign_mode: "1",
      });
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.agreementData = data;
      }
    },
    // 获取用户信息
    async getUser() {
      let result = await this.$http.post("/manager/getCompanyManagerInfo");
      if (result.data.status === 1) {
        this.name = result.data.data.company.team_name
          ? result.data.data.company.team_name
          : result.data.data.company.companyInfo.qichacha_name;
      }
    },
    // 提交
    async onSubmit() {
      let form1 = false;
      let formData;
      this.$refs.formcard1.form.validateFields((err, values) => {
        if (!err) {
          formData = values;
          console.log("TCL: onSubmit -> formData", formData);
          form1 = true;
        }
      });
      this.list = this.agreement_service.filter((item, index) => {
        console.log(item);

        if (item.need_relation_product == 1 && item.need_show_product == 1) {
          // 关联产品、资料、和展示的产品都需要
          return (
            this.selectedRowKeys.includes(item.service_id) &&
            item.plan_num &&
            this.service_data_selectArr[item.service_id] != undefined &&
            this.service_data_selectArr[item.service_id].length &&
            this.service_product_selectArr[item.service_id] != undefined &&
            this.productSelects[item.service_id] != undefined &&
            this.productSelects[item.service_id].length
          );
        } else if (item.need_relation_product == 1) {
          // 关联产品、资料需要
          return (
            this.selectedRowKeys.includes(item.service_id) &&
            item.plan_num &&
            this.service_data_selectArr[item.service_id] != undefined &&
            this.service_data_selectArr[item.service_id].length &&
            this.service_product_selectArr[item.service_id] != undefined
          );
        } else if (item.need_show_product == 1) {
          //展示的产品
          return (
            this.selectedRowKeys.includes(item.service_id) &&
            item.plan_num &&
            this.productSelects[item.service_id] != undefined &&
            this.productSelects[item.service_id].length
          );
        }

        return this.selectedRowKeys.includes(item.service_id) && item.plan_num;
      });

      // 至少选择一个项目勾选必填
      if (
        this.list.length === 0 ||
        this.list.length !== this.selectedRowKeys.length
      ) {
        this.$message.error("请在任务详情指定本次推广的服务项目并填写完善");
        return;
      }

      // 处理选择的资料ID
      let map_id = [];
      let that = this;
      this.service_data_selectArr.map(function (item, index) {
        if(that.selectedRowKeys.includes(index)){
          map_id[index] = item.map(function (subitem) {
            return subitem.substr(0, subitem.indexOf("_+_"));
          });
        }
      });

      // 处理选择的关联产品
      let link_products = [];
      this.service_product_selectArr.map(function (item, index) {
        if(that.selectedRowKeys.includes(index)){
          link_products[index] = item;
        }
      });
      
      let data = {
        id: this.$route.query.id ? this.$route.query.id : undefined,
        agreement_id: this.agreement_id,
        title: formData.title,
        plan_start_time: this.$moment(formData.plan_time[0]).unix(),
        plan_end_time: this.$moment(formData.plan_time[1]).unix(),
        materials_cost: formData.materials_cost
          ? parseFloat(formData.materials_cost)
          : undefined,
        link_services: this.list,
        // map_id: map_id,
        product_selects: this.productSelects,
        product_specs: this.product_specs,
        // link_products: link_products,
      };
      if(map_id.length){
        data = {...data, map_id:map_id};
      }
      if(link_products.length){
        data = {...data, link_products:link_products};
      }
  
      if (form1) {
        this.btnIsLoading = true;
        let result = await this.$http.post("/WorkPlan/update", data);
        this.btnIsLoading = false;
        if (result.data.status === 1) {
          this.$message.success("操作成功！");
          this.$router.back();
        }
      }
    },
    // 取消
    onCancel() {
      this.$router.back();
    },
    // 选择协议
    handleSelect(value) {
      this.agreement_id = value;
      let data = this.agreementData.find((item) => {
        return item.id === value;
      });
      this.cooperation_company_id = data.company_id;

      // 获取服务活动列表
      this.agreement_service = data.agreement_service.map((item) => {
        return {
          service_id: item.id,
          name: item.name,
          budget: item.budget,
          need_relation_product: item.need_relation_product,
          need_show_product: item.need_show_product,
          plan_num: undefined,
          offline_share: { offline: false, share: false },
        };
      });

      this.data1 = {
        province_city: {
          province: data.province,
          city: data.city ? data.city : "",
        },
        company: data.company_info.team_name,
        title: data.title,
        plan_time: [
          this.$Moment(data.service_start_time),
          this.$Moment(data.service_end_time),
        ],
        budget: data.budget,
      };
      this.getProducts();
    },
    // 表格选中
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
};
</script>
<style>
.datas_drop_down {
  width: auto !important;
  min-width: 200px;
}
</style>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  margin-bottom: 40px;
  .business-scope-wrapper {
    .business-scope-head {
      margin-top: -35px;
      font-size: 16px;
    }
    .business-scope-content {
      background: rgba(249, 249, 252, 1);
      border-radius: 10px;
      padding: 20px;
      margin: 20px 10px;
      min-height: 100px;
    }
  }
  .form-card-wrapper {
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-upload {
    .upload-title {
      position: relative;
      top: -9px;
      right: -191px;
      color: #c3c7d5;
      font-size: 12px;
    }
    .ant-upload-text {
      color: #d6daea;
      margin-top: 50px;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 0 -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transform: translateY(10px);
  }
  .table-input {
    padding-top: 28px;
    .error-note {
      margin-top: 6px;
      color: #f5222d;
      height: 20px;
    }
  }
  .form-card-title {
    border-left: 1px solid #46d3dd;
    margin-left: -32px;
    padding-left: 20px;
    font-size: 16px;
    color: #565c66;
    .error-note-title {
      color: #f5222d;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .input-number {
    width: 100px;
  }
}
</style>
